import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface WarningIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const WarningIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: WarningIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12 13V9"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M12 16.5V16.63"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2679 5C11.0377 3.66667 12.9622 3.66667 13.732 5L20.6602 17C21.43 18.3333 20.4678 20 18.9282 20H5.07177C3.53217 20 2.56992 18.3333 3.33972 17L10.2679 5Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default WarningIcon
